import React from "react";
import { useHistory } from "react-router-dom";

function GetMentored() {
  const history = useHistory();

  const onSubmit = (input) => {
    history.push({
      pathname: "/mentors",
      state: input,
    });
  };

  return (
    <div>
      <div className="container px-5 pt-12 mx-auto ">
        <div className="flex flex-wrap w-full mb-4 sm:mb-16 ">
          <div className="lg:w-1/2 w-full mb-6 lg:mb-0">
            <h1 className="sm:text-3xl text-2xl font-bold title-font mb-2 text-gray-900">
              Ways to get mentored in this community
            </h1>
          </div>
        </div>
        <div className="flex flex-wrap -m-4 mb-16 ">
          <div className="p-4 md:w-1/3 sm: w-full">
            <div
              className="block rounded-lg relative p-5 transform transition-all duration-300 scale-100 hover:scale-95"
              style={{
                background:
                  "url(https://images.unsplash.com/photo-1573167130797-8453176c73d0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1650&q=80)",
                backgroundSize: "cover",
              }}
            >
              <div className="flex w-80 sm:w-full align-text-top">
                <h2 className="text-white text-2xl font-bold leading-tight mb-3 pr-5">
                  Get amazing career advice to grow and build.
                </h2>
              </div>
              <div className="h-44"></div>

              <div className="flex w-full items-center text-sm text-black font-medium">
                <div className="flex-1 flex items-center">
                  <button
                    onClick={() => onSubmit("Career advice")}
                    className="bg-white p-2 rounded-lg"
                  >
                    See more
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 md:w-1/3 sm: w-full">
            <div
              className="block rounded-lg relative p-5 transform transition-all duration-300 scale-100 hover:scale-95"
              style={{
                background:
                  "url(https://images.unsplash.com/photo-1511376979163-f804dff7ad7b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=668&q=80)",
                backgroundSize: "cover",
              }}
            >
              <div className="flex w-80 sm:w-full align-text-top">
                <h2 className="flex-wrap text-white text-2xl font-bold leading-tight mb-3 pr-5">
                  Prepare by learning about interview tips.
                </h2>
              </div>
              <div className="h-44"></div>

              <div className="flex w-full items-center text-sm text-black font-medium">
                <div className="flex-1 flex items-center">
                  <button
                    onClick={() => onSubmit("Interview tips")}
                    className="bg-white p-2 rounded-lg"
                  >
                    See more
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 md:w-1/3 sm: w-full">
            <div
              className="block rounded-lg relative p-5 transform transition-all duration-300 scale-100 hover:scale-95"
              style={{
                background:
                  "url(https://images.unsplash.com/photo-1607294846590-fd005d7973e8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1163&q=80)",
                backgroundSize: "cover",
              }}
            >
              <div className="flex w-80 sm:w-full align-text-top">
                <h2 className="text-white text-2xl font-bold leading-tight mb-3 pr-5">
                  Connect to learn from leaders around the world.
                </h2>
              </div>
              <div className="h-44"></div>

              <div className="flex w-full items-center text-sm text-black font-medium">
                <div className="flex-1 flex items-center">
                  <button
                    onClick={() => onSubmit("Open source")}
                    className="bg-white p-2 rounded-lg"
                  >
                    See more
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetMentored;
